/* eslint-disable import/no-anonymous-default-export */
import toNumber from "lodash/toNumber"

// Addons 2024-05-19
const host_divk = process.env.REACT_APP_DIVISION_K || ''

export default ({ divisionlogin='E', amount= 0.00, digit= 2 }) => {
  console.log(`2024-05-19 :: decimalDigit.js ==> divisionlogin ==> `,divisionlogin)
  console.log(`2024-05-19 :: decimalDigit.js ==> host_divk ==> `,host_divk)

  let amountConvert = 0.00
  if(divisionlogin === host_divk){
    console.log(`2024-05-19 :: decimalDigit in case div.K`)
    amountConvert = Math.round(1000 * amount) / 1000
  }else{
    console.log(`2024-05-19 :: decimalDigit in case div.E`)
    amountConvert = Math.floor(100 * amount) / 100
  }

  return toNumber(amountConvert.toFixed(digit))
}